import React from "react";

export const SupportInfo = ({ closeBox, mobile }) => {
	return (
		<div>
			<div className="support-info-veil" onClick={closeBox} />
			<div className="support-info-object">
				<div className="dx-col">
					<div className="support-info-content" >

						<div className="dx-col">
							<div className="support-info-head">
								<header> Contact Support </header>
							</div>
							<div className="support-info-text">
								<p>
									Questions? Need help with your account?<br />{" "}
									Contact us using any of the below methods.
								</p>
							</div>
							<div className="support-info-items">
								<div className="item">
									{mobile ? (
										<div>
											<div className="item-image">
												{" "}
												<img src="media/icons/icon-phone-circle.svg" alt="phone"/>{" "}
												</div>
												<div className="item-head">
										      <a href="tel:+1-888-978-5371" target="_blank" rel="noopener noreferrer" data-rel="external">
														1-888-978-5371{" "}
												  </a><br />
										      <span className="item-head-details">Press 3</span>
										    </div>
										</div>
									) : (
										<div>
											<div className="item-image">
												{" "}
												<img src="media/icons/icon-phone-circle.svg" alt="phone"/>{" "}
											</div>
											<div className="item-head" x-ms-format-detection="none">
												{" "}
												1-888-978-5371<br />
										    <span className="item-head-details">Press 3</span>
										    {" "}
											</div>
										</div>
									)}

									<div className="item-description">
										{" "}
									  Our team is available Mon-Fri 8:00 am – 7:00 pm ET.{" "}
									</div>
								</div>
								<div className="item">
									<a className="support-email" href="mailto:billing@privateclientselect.com" target="_blank" rel="noopener noreferrer" data-rel="external">
										<div className="item-image">
											{" "}
											<img src="media/icons/icon-mail-circle.svg" alt="mail"/>{" "}
										</div>
										<div className="item-head">
										billing@privateclientselect.com
										</div>
									</a>
									<div className="item-description">
										{" "}
										Please allow 1 business day for a
										response.{" "}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/SupportInfo/SupportInfo.js